module.exports = __webpack_public_path__ + "media/IBMPlexSans-Regular.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/IBMPlexSans/IBMPlexSans-Regular.woff2
// module id = 1473
// module chunks = 58